import store from 'js/store';
import { postCosmosApiData, getCosmosApiData, apiErrorOccurred } from 'js/helpers/apiData';
import { FEEDBACK_MENU_UPDATE, FEEDBACK_MENU_LOAD, FEEDBACK_MENU_SUBMIT, FEEDBACK_MENU_SUBMIT_END } from '../reducers/nav/feedbackMenu';
var FEEDBACK_MENU_API_URL = '/feedback_menu';
export function updateFeedbackMenuMetadata(metadata) {
  return {
    type: FEEDBACK_MENU_UPDATE,
    metadata: metadata
  };
}
export function feedbackMenuMetadataLoad() {
  return {
    type: FEEDBACK_MENU_LOAD
  };
}
export function feedbackMenuSubmit() {
  return {
    type: FEEDBACK_MENU_SUBMIT
  };
}
export function feedbackMenuSubmitEnd() {
  return {
    type: FEEDBACK_MENU_SUBMIT_END
  };
}
export function fetchAndUpdateFeedbackMenuMetadata() {
  return function (dispatch) {
    if (store.getState().feedbackMenu.metadata) return;
    dispatch(feedbackMenuMetadataLoad());
    return getCosmosApiData(FEEDBACK_MENU_API_URL).then(function (feedbackMenuMetadata) {
      dispatch(updateFeedbackMenuMetadata(feedbackMenuMetadata));
    }).catch(function (error) {
      // If there was an error fetching the data, invalidate the data
      if (apiErrorOccurred(error)) {
        dispatch(updateFeedbackMenuMetadata(null));
      } // TODO: throw error here still?


      throw error;
    });
  };
}
export function postFeedback(postFormData) {
  return function (dispatch) {
    dispatch(feedbackMenuSubmit());
    return postCosmosApiData(FEEDBACK_MENU_API_URL, null, postFormData).then(function () {
      dispatch(feedbackMenuSubmitEnd());
    }).catch(function (error) {
      if (apiErrorOccurred(error)) {// TODO: move the code below up here?
      }

      dispatch(feedbackMenuSubmitEnd()); // TODO: throw error here still?

      throw error;
    });
  };
}